var H = require("hogan.js");
window.gettext || require("ehogan-loader/gt.js");
window.jscAdd || require("ehogan-loader/jscmanager.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<!-- parametres: authUrl -->");t.b("\n" + i);t.b(t.t(interpolate( gettext("Пользователь с указанным e-mail уже существует. %(linkTagOpenBegin)s%(url)s%(linkTagOpenEnd)sВойти%(linkTagClose)s."), {'linkTagOpenBegin': '<a href="', 'url': t.d("authUrl",c,p,1)||"",'linkTagOpenEnd': '">','linkTagClose': '</a>'} , true)));t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<!-- parametres: authUrl -->\n{{{ ___29___ }}}\n", H);return T[arguments[0] instanceof Array ? "ri" : "render"].apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ./static-source/messages/login_exist.html
// module id = 201
// module chunks = 4